import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import TextConditions from './TextConditions';

export default function GeneralConditions() {
  const { t } = useTranslation(['layout']);
  const templateId = useSelector((state) => state.applicationState.templateId);
  const company = useSelector((state) => state.applicationState.templateData.header.empresa);
  const emailContacto = useSelector(
    (state) => state.applicationState.templateData.header.emailContacto,
  );

  return (
    <div className="pt-7 pb-10 py-5 container">
      <div className="px-12 py-12 bg-white rounded-md">
        <div className="text-sm text-gray-400 font-bold">
          {templateId === 1 && (
            <>
              <p className="mb-1">
                {`Sr. Pasajero, atento su requerimiento de intermediación en la contratación de servicios turísticos , esta Agencia cumple en informarle las condiciones generales de contratación. Es de vital importancia para su viaje, que Ud. lea las mismas. Si está de acuerdo le solicitamos nos envíe  su aceptación al siguiente mail: ${emailContacto}.`}
              </p>
              <p className="mb-6">
                {`Esta agencia sólo dará tramite a su reserva, previa lectura y conformidad de las mismas. Atte: ${company} Agencia`}
              </p>
            </>
          )}
        </div>
        <h3 className="text-xl text-black text-center">
          <span className="underline">
            <strong>
              {templateId === 2
                ? 'Política de Privacidade'
                : templateId === 3
                ? 'Políticas de Privacidad'
                : t('footer.generalConditions')}
            </strong>
          </span>
        </h3>
        <div className="text-sm text-gray-400 py-12">
          <TextConditions templateId={templateId} />
        </div>
      </div>
    </div>
  );
}
